import React from "react";
import { connect } from "react-redux";
import { Box, Chip, Grid, LinearProgress, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import StatBoxSlim from "components/Stats/StatBoxSlim";
import * as V from "styles/variables";

const useStyles = makeStyles(() => ({
  summaryItem: {
    "@media (min-width: 1280px)": {
      flexBasis: "20%",
      maxWidth: "20%",
    },
  },
  progressLabel: {
    marginTop: 32,
    flexGrow: 1,
    textAlign: "right",
    fontSize: 13,
  },
  progressTooltip: {
    position: "absolute",
    top: 8,
    left: "50%",
    transform: "translateX(-50%)",
    whiteSpace: "nowrap",
  },
}));

const CheckInOverviewCommon = ({ homeDataCheckInOverview = {}, selectedSeason = [] }) => {
  const classes = useStyles();
  const valueOrDash = (value) => value !== undefined ? value : "-";
  const status = homeDataCheckInOverview.status;

  if (status === "error") {
    return <Chip label="データ取得エラー" style={{ color: V.textColor, backgroundColor: V.placeholderColor }} />;
  }

  if (status === "empty") {
    return <Chip label="No Data" style={{ color: V.textColor, backgroundColor: V.placeholderColor }} />;
  }

  const hasProgress = status === "success" && selectedSeason.length > 0;
  const achievementRate = Number(homeDataCheckInOverview.achievementRate) || 0;
  const registeredAssetCount = Number(homeDataCheckInOverview.registeredAssetCount) || 0;

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} lg={10}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} md={4} lg={4} className={classes.summaryItem}>
            <StatBoxSlim title="チェックイン数" value={valueOrDash(homeDataCheckInOverview.checkinCount)} />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} className={classes.summaryItem}>
            <StatBoxSlim title="チェックイン対象アセット数" value={valueOrDash(homeDataCheckInOverview.uniqueCheckinAssetCount)} />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} className={classes.summaryItem}>
            <StatBoxSlim title="チェックイン者数" value={valueOrDash(homeDataCheckInOverview.uniqueCheckinUserCount)} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} lg={2}>
        {hasProgress && registeredAssetCount > 0 && (
          <>
            <Typography variant="body2">
              {`${selectedSeason[0].seasonStart.split(" ")[0]} ~ ${selectedSeason[0].seasonEnd.split(" ")[0]} チェックイン達成率`}
            </Typography>
            <div className={classes.progressLabel}>
              <Box width="100%" position="relative">
                <Box className={classes.progressTooltip}>
                  {`${homeDataCheckInOverview.uniqueCheckinAssetCount} (${achievementRate.toFixed(2)}%)`}
                </Box>
                <LinearProgress variant="determinate" value={Math.min(achievementRate, 100)} />
                <Box display="flex" justifyContent="space-between" mt={1}>
                  <Typography variant="body2" color="textSecondary">0</Typography>
                  <Typography variant="body2" color="textSecondary">{registeredAssetCount}</Typography>
                </Box>
              </Box>
            </div>
          </>
        )}
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  homeDataCheckInOverview: state.pictreeCommon.homeDataCheckInOverview,
  selectedSeason: state.pictreeCommon.selectedSeason,
});

export default connect(mapStateToProps)(CheckInOverviewCommon);
